import React from 'react';
import { Block } from '@mui/icons-material';
import nswf1 from "../img/nsfw/nswf1.png";
import nswf2 from "../img/nsfw/nswf2.png";
import nswf3 from "../img/nsfw/nswf3.png";

const Nswf = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">NSFW content to avoid in RUNWAY type task</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-3-vertical">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={nswf1} alt="NSFW content example 1" onClick={() => onImageClick && onImageClick(nswf1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Inappropriate content for social media (pants)
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={nswf2} alt="NSFW content example 2" onClick={() => onImageClick && onImageClick(nswf2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
              Inappropriate content for social media (lowcut)
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={nswf3} alt="NSFW content example 3" onClick={() => onImageClick && onImageClick(nswf3)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
              Inappropriate content for social media (lowcut)
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default Nswf;